import type { MomentCoupon } from "../../data/momentOptions";

type Props = {
  couponEnabled: boolean;
  coupon: MomentCoupon;
  compact?: boolean;
};

function getCouponTitle(coupon: MomentCoupon) {
  const title = coupon.couponBookTitle.trim();
  switch (coupon.couponBookTitleType) {
    case "DISCOUNT_PRICE": return `${title || "0"}원 할인 쿠폰`;
    case "DISCOUNT_RATE": return `${title || "0"}% 할인 쿠폰`;
    case "FREE_SHIPPING": return "배송비 할인 쿠폰";
    case "FREE_GIFT": return `${title || "무료"} 쿠폰`;
    case "UPGRADE":
    default: return `${title || "UP"} 쿠폰`;
  }
}

export default function CouponPreview({ couponEnabled, coupon, compact }: Props) {
  if (!couponEnabled) return null;

  const couponTitle = getCouponTitle(coupon);

  if (compact) {
    return (
      <div className="tw-mt-2 tw-rounded tw-border tw-border-[#b8c2cf] tw-overflow-hidden tw-shadow-[inset_0_0_0_1px_rgba(184,194,207,0.8)]">
        <div style={{ display: "flex", minHeight: "56px" }}>
          <div style={{ display: "flex", flex: 1, minWidth: 0, alignItems: "center", padding: "0 10px" }}>
            <div style={{ minWidth: 0, display: "flex", flexDirection: "column", justifyContent: "center", padding: "4px 0" }}>
              <p className="tw-text-[10px] tw-font-bold tw-text-gray-800 tw-leading-[1.15] tw-break-all">
                {couponTitle}
              </p>
              <p className="tw-mt-0 tw-text-[9px] tw-text-gray-500 tw-leading-[1.1] tw-break-all">
                {coupon.title.trim() || "쿠폰 상세 설명"}
              </p>
            </div>
          </div>
          <div style={{ display: "flex", width: "44px", flexShrink: 0, alignItems: "center", justifyContent: "center", borderLeft: "1px solid #c5ccd6", backgroundColor: "#edf5ff" }}>
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-[#1677ff]">
              <span className="tw-text-[13px] tw-font-medium tw-leading-none">↓</span>
              <span className="tw-text-[6px] tw-font-bold tw-tracking-widest">COUPON</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tw-mx-4 tw-mb-3 tw-overflow-hidden tw-rounded-lg tw-border tw-border-[#c5ccd6] tw-bg-white tw-shadow-[inset_0_0_0_1px_rgba(197,204,214,0.85)]">
      <div style={{ display: "flex", height: "54px" }}>
        <div style={{ display: "flex", flex: 1, minWidth: 0, alignItems: "center", padding: "0 12px" }}>
          <div style={{ minWidth: 0, textAlign: "left", display: "flex", flexDirection: "column", justifyContent: "center", padding: "5px 0" }}>
            <strong className="tw-block tw-text-[12px] tw-font-bold tw-leading-[1.15] tw-text-gray-800">
              {couponTitle}
            </strong>
            <p className="tw-mt-0 tw-text-[11px] tw-leading-[1.1] tw-text-gray-500 tw-break-all">
              {coupon.title.trim() || "쿠폰 상세 설명"}
            </p>
          </div>
        </div>
        <div style={{ display: "flex", width: "52px", flexShrink: 0, alignItems: "center", justifyContent: "center", borderLeft: "1px solid #c5ccd6", backgroundColor: "#edf5ff" }}>
          <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-leading-none tw-text-[#1677ff]">
            <span className="tw-text-[18px] tw-font-medium tw-leading-none">↓</span>
            <span className="tw-mt-0.5 tw-text-[7px] tw-font-bold tw-tracking-[0.16em]">COUPON</span>
          </div>
        </div>
      </div>
    </div>
  );
}
